"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CodeFieldDestination = void 0;
var tslib_1 = require("tslib");
var destination_type_1 = require("../utils/destination-type");
var field_sub_destination_1 = require("./field-sub-destination");
var CodeFieldDestination = (function (_super) {
    tslib_1.__extends(CodeFieldDestination, _super);
    function CodeFieldDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CodeFieldDestination.prototype, "destinationType", {
        get: function () { return destination_type_1.DestinationType.CodeFieldDestination; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CodeFieldDestination.prototype, "currentInfo", {
        get: function () { return this.importer.importers.field.currentField; },
        enumerable: false,
        configurable: true
    });
    CodeFieldDestination.prototype.createInstance = function () {
        return new CodeFieldDestination(this.importer);
    };
    CodeFieldDestination.prototype.processTextCore = function (text) {
        this.currentInfo.instruction += text;
        this.importer.importers.field.ensureStartMarkAdded();
        _super.prototype.processTextCore.call(this, text);
    };
    CodeFieldDestination.prototype.processCharCore = function (ch) {
        this.currentInfo.instruction += ch;
        this.importer.importers.field.ensureStartMarkAdded();
        _super.prototype.processCharCore.call(this, ch);
    };
    CodeFieldDestination.prototype.onDestinationClose = function () {
        var fieldType = this.getCurrentFieldType();
        this.currentInfo.isShapeField = fieldType == "shape";
        var fieldImporter = this.importer.importers.field;
        fieldImporter.ensureStartMarkAdded();
        fieldImporter.ensureSeparatorMarkAdded();
    };
    CodeFieldDestination.prototype.getCurrentFieldType = function () {
        var tokens = this.currentInfo.instruction.split(/\s+/);
        var result = tokens.filter(function (token) { return token !== ''; })[0];
        return result ? result.toLowerCase() : result;
    };
    return CodeFieldDestination;
}(field_sub_destination_1.FieldSubDestination));
exports.CodeFieldDestination = CodeFieldDestination;
